var React = require('react');

function Send (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.5"},React.createElement("path",{"d":"M16 2L8.3 9.7M16 2l-4.9 14-2.8-6.3L2 6.9z"})));
}

Send.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = Send;

Send.default = Send;
